import { TemplateElement, html } from '@webtides/element-js';
import ColorButtonEvent from './ColorButtonEvent.js';
import { classMap } from 'lit-html/directives/class-map.js';
import style from './color-button.css';
export default class ColorButton extends TemplateElement {
    constructor(options) {
        super({ shadowRender: false, styles: [style], ...options });
    }

    properties() {
        return {
            active: false,
            disabled: false,
            renderDisabledAttribute: true,
            label: '',
            colors: [],
            mouseover: false,
            small: false,
            renderLabel: true,
        };
    }

    connected() {
        this.setColorProperties();
    }

    afterUpdate() {
        this.setColorProperties();
    }

    events() {
        return {
            this: {
                mouseenter: () => {
                    this.mouseover = true;
                },
                mouseleave: () => {
                    this.mouseover = false;
                },
                click: () => {
                    this.dispatch(ColorButtonEvent.COLOR_CLICK);
                    if (!this.disabled) {
                        this.dispatch(ColorButtonEvent.COLOR_CLICK_ENABLED);
                    }
                },
            },
        };
    }

    getLabel() {
        if (this.label === '' || !this.renderLabel) {
            return '';
        }

        const labelClasses = {
            'opacity-100': this.active || this.mouseover,
            'text-brand-500': this.active,
            'text-grey-500': !this.active,
        };
        return html` <div class="label opacity-0 mt-2 text-sm  ${classMap(labelClasses)}">${this.label}</div> `;
    }
    setColorProperties() {
        const getColorValue = color => {
            if (color === 'multicolor') return 'var(--button-gradient-rainbow)';
            return color.length === 6 && color.charAt(0) !== '#' ? `#${color}` : color;
        };

        const first = getColorValue(this.colors[0]);
        this.style.setProperty('--color-button-bg', first);

        if (this.colors.length === 1) return;

        const stops = 100 / this.colors.length;

        const colorStops = [];
        this.colors.forEach((color, index) => {
            if (color !== 'multicolor') {
                colorStops.push(`${getColorValue(color)} ${stops * index}%`);
                colorStops.push(`${getColorValue(color)} ${stops * (index + 1)}%`);
            } else {
                colorStops.push(`transparent ${stops * index}%`);
                colorStops.push(`transparent ${stops * (index + 1)}%`);
            }
        });

        const gradient =
            `linear-gradient( to right, ${colorStops.join(',')} )` +
            `${this.containsMultiColor ? `,var(--button-gradient-rainbow)` : ''}`;

        this.style.setProperty('--color-button-bg', gradient);
    }

    get containsMultiColor() {
        return this.colors.some(color => color === 'multicolor');
    }

    getCircleClasses() {
        return {
            'border-transparent': !this.active,
            'h-10': !this.small,
            'w-10': !this.small,
            'h-8': this.small,
            'w-8': this.small,
        };
    }

    template() {
        const circleClasses = this.getCircleClasses();
        const btnClasses = {
            'is-active': this.active,
            'is-disabled': this.disabled,
            'is-hovered': this.mouseover && !this.active,
        };

        return html`
            <button
                class="focus:outline-none flex flex-col items-center ${classMap(btnClasses)}"
                ?disabled="${this.disabled && this.renderDisabledAttribute}"
            >
                <div class="outer-circle rounded-full ${classMap(circleClasses)}">
                    <div class="inner-circle rounded-full border border-grey-300 w-full h-full "></div>
                </div>
                ${this.getLabel()}
            </button>
        `;
    }
}
